document.addEventListener('DOMContentLoaded', function() {
  var description = document.querySelector('.rte.reading-width.align-center.large-text');
  if (description) {
    var children = Array.from(description.children);
    var firstParagraph = children.find(child => child.tagName === 'P');
    
    if (firstParagraph && children.length > 1) {
      var wrapper = document.createElement('div');
      wrapper.className = 'description-wrapper';
      var readMoreContent = document.createElement('div');
      readMoreContent.className = 'read-more-content';

      var isFirstParagraphPassed = false;
      children.forEach(child => {
        if (isFirstParagraphPassed) {
          readMoreContent.appendChild(child);
        } else if (child === firstParagraph) {
          isFirstParagraphPassed = true;
        }
      });

      firstParagraph.insertAdjacentElement('afterend', wrapper);
      wrapper.appendChild(readMoreContent);

      var readMoreBtn = document.createElement('button');
      readMoreBtn.className = 'read-more-btn';
      readMoreBtn.textContent = 'READ MORE';

      wrapper.insertAdjacentElement('beforebegin', readMoreBtn);

      readMoreBtn.addEventListener('click', function() {
        readMoreContent.classList.toggle('expanded');
        readMoreBtn.textContent = readMoreContent.classList.contains('expanded') ? 'READ LESS' : 'READ MORE';
      });
    }
  }
});